<template>
  <Container class="container-sm-none">
    <Card class="card-shadow mt-15 mt-md-0">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
        <IconFamily />
        <p class="heading-2 heading-md-1 weight-medium mt-20">
          Your application has been successfully signed!
        </p>
        <p class="body-3 body-md-1 text-left weight-regular mt-10">
          We have emailed you your signed application together with useful information.
        </p>
        <p class="heading-3 mt-20">
          undefined
        </p>
        <Card class="card-border-gray-300 p-10 mt-10 b-rounded-12">
            <div class="flex gap-6 w-full">
                <CircleNumber :value="1" />
                <p class="body-3 mt-2 mb-0 text-left">
                    We have emailed you your signed application which you can save or print.
                </p>
            </div>

            <div class="flex gap-6 mt-10 w-full">
                <CircleNumber :value="2" />
                <p class="body-3 mt-2 mb-0 text-left">
                  Once your qualified electronic signature has been verified, we will confirm the validity of your application by e-mail.
                </p>
            </div>
        </Card>
        <h3 class="mt-20">
          Thank you for choosing us.
        </h3>
        <div class="width-md mt-20">
          <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
            <p class="m-0 pr-md-5 weight-regular body-3">
              You can close the browser window.
            </p>
          </InfoBox>
        </div>
    </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import IconFamily from '@/components/Icons/IconFamily.vue';
import CircleNumber from '@/components/CircleNumber/CircleNumber.vue';
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import enums from '../../mixins/enums';
import url from '../../mixins/url';
import GA from '../../mixins/GA';

export default {
  name: 'ESignatureSuccess',
  mixins: [enums, url, GA],
  components: {
    InfoBox,
    Container,
    IconFamily,
    CircleNumber,
    Card,
  },
  props: {
    model: { required: true, type: Object },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;

    this.esignFunnelCompleted();
  },
};
</script>
